// extracted by mini-css-extract-plugin
module.exports = {"popover":"Zf0yqh2G","close":"f3_fOHON","img":"Dg8irJlY","icon":"__9pzjkUWD"};